

import colors from "../../utils/colors";
import { createUseStyles } from 'react-jss';

var styles = {
  tableHead: {
    display: 'block',
    width: '100%',
    font: {
      size: '1.4rem',
      lineHeight: '2rem',
      weight: 700,
      style: 'normal'
    },
    letterSpacing: '0.05rem',
    textTransform: 'uppercase',
    borderBottom: ['0.1rem', 'solid', colors.neutral[500]]
  }
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map